import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';

import { Container, Icon, Anchor, Button } from 'Components/core';

import InfoBoxHeader from 'Components/InfoBox/InfoBoxHeader';
import InfoBoxContent from 'Components/InfoBox/InfoBoxContent';

// Cards
import CardContainer from 'Components/Card/CardContainer';
import CardHighlighted from 'Components/Card/CardHighlighted';

// Images
import Chart from './images/pay_imager@2x.png';
import { Subscribe, ApiStore } from 'Store';
import Api from 'Root/libs/analytics/Api';
import CODES from 'Root/libs/analytics/CodeDef';
import {
  HeaderV2,
  SubHeader,
  TitleHeader,
  TitleHeader2
} from 'Components/core/Header';
import PaddedContainer from 'Components/core/PaddedContainer';

const Card = styled.div`
  margin-right: 20px;
  background-color: #ddeefa;
  margin-top: 30px;

  border-radius: 8px;
  background: #fff;
  border: 1px solid #1355e9;
  width: 312px;
  

  ${props => (props.borderless ? 'visibility:hidden;' : '')}

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    margin-right: 0px;
  }
`;

const CardContainerCustom2 = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;


  @media screen and (max-width: ${layout.breakpoints.mobile}) {
      justify-content:center ;
      align-items:center ;
      
  }


  > * p {
    padding: 20px;
    padding-top: 0px;
  }
`;

const Header = styled.div`
  height: 50px;
  background-color: #0072bb;
  color: #ffffff;
  padding: 15px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: bold;

  height: 76px;
  border-radius: 8px 8px 0px 0px;
  background: #1355e9;

  :after {
    content: ':';
  }
`;

const CardContainerCustom = styled(CardContainer).attrs(props => ({
  border: false
}))`
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    > * + * {
      margin-top: 24px;
    }
    > * {
      width: auto;
    }
  }
`;
const CardHighlightedCustom = styled(CardHighlighted).attrs(props => ({
  textAlign: 'left',
  alignItems: 'flex-start'
}))`
  position: relative;
  margin-left: 48px;

  > *:nth-child(2) {
    margin-top: 0;
  }
`;
const CardNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2em;
  position: absolute;
  top: 16px;
  left: -40px;
  width: 60px;
  height: 60px;
  background-color:#081f65;//${colors.accent};
  color: ${colors.textOnAccent};
`;

export default () => {
  useEffect(() => {
    Api.recordAcitity(CODES.MENU_HOW_PW);
  }, []);

  return (
    <Subscribe to={[ApiStore]}>
      {state => (
        <Container column maxWidth style={{ margin: 'auto' }}>
          <HeaderV2 title={'Understanding Healthcare Terms'}></HeaderV2>
          <PaddedContainer column>
            <Container column style={{ marginTop: 40, marginBottom: 10 }}>
              <CardContainerCustom2>
                <Card>
                  <Header>Deductible</Header>
                  <p>
                    A set amount you pay each year for covered services before
                    your plan starts to pay for covered health care costs.
                  </p>
                  {typeof state.howPlanWorks?.type === 'string' && (
                    <p>
                      You can use your {state.howPlanWorks.type} toward your
                      deductible.
                    </p>
                  )}
                </Card>
                <Card>
                  <Header>Copay</Header>
                  <p>
                    A flat fee you pay for covered services like doctor visits.
                  </p>
                </Card>
                <Card>
                  <Header>Coinsurance</Header>
                  <p>
                    Once you've met your deductible, you and your health plan
                    share the cost of covered health care services. The
                    coinsurance is your share of the costs, usually a percentage
                    of the cost of care. Your plan details show what portion of
                    the cost you'll pay.
                  </p>
                </Card>

                <Card>
                  <Header>Out-of-pocket limit</Header>
                  <p>
                    This is the most you have to pay out of your own pocket each
                    year for covered services. This amount may include your
                    deductible and your percentage of the costs, depending on
                    your plan. And some plans may still have you pay a copay at
                    the time of service.
                  </p>
                </Card>
                <Card>
                  <Header>Premium</Header>
                  <p>
                    The premium is what you pay
                    for the plan. It's the money that comes out of your
                    paycheck.
                  </p>
                </Card>
                <Card borderless style={{ backgroundColor: 'inherit' }}></Card>
              </CardContainerCustom2>
            </Container>
          </PaddedContainer>
          <Container column seperation="32px">
            <PaddedContainer
              style={{
                background: '#edf6fd',
                paddingTop: 60,
                paddingBottom: 30,
                marginBottom: 60
              }}
              column
            >
              <TitleHeader2 align="center">
                What you pay and what your plan pays
              </TitleHeader2>

              <img
                alt="You pay until you reach your deductible. At this point, you and your plan share the cost until the out-of-pocket limit is reached. At this point, your plan pays the costs."
                src={Chart}
              />
            </PaddedContainer>
          </Container>

          <Container column seperation="32px">
            <PaddedContainer column>
              <TitleHeader2 align="center">
                How to pick a plan – the 4 Cs
              </TitleHeader2>
              <CardContainerv2 style={{marginTop:50,marginBottom:40}}>
                <Cardv2>
                  <CardIcon size="2x">1</CardIcon>
                  <p>
                    <b>Consider</b> your personal situation. If things have
                    changed since last year, you may want to look for benefits
                    that fit those needs.
                    <ul>
                      <li>Have your health care needs changed?</li>
                      <li>Do you go to the doctor more often now?</li>
                      <li>Are you taking a special prescription drug?</li>
                      <li>Expecting a baby?</li>
                    </ul>
                  </p>
                </Cardv2>
                <Cardv2>
                <CardIcon size="2x">2</CardIcon>
                  <p>
                    <b>Compare</b> all the costs
                    <ul>
                      <li>Monthly payment</li>
                      <li>Deductible</li>
                      <li>Coinsurance</li>
                      <li>Copay</li>
                      <li>Out-of-pocket limit</li>
                    </ul>
                  </p>
                </Cardv2>

                <Cardv2>
                <CardIcon size="2x">3</CardIcon>
                  <p>
                    <b>Check</b> to see if your doctors, hospitals and other
                    health care professionals are covered by the plan.
                  </p>
                </Cardv2>
                <Cardv2>
                <CardIcon size="2x">4</CardIcon>
                  <p>
                    <b>Choose</b> the right plan for your needs.
                  </p>
                </Cardv2>
              </CardContainerv2>
            </PaddedContainer>
          </Container>
        </Container>
      )}
    </Subscribe>
  );
};

const CardContainerv2 = styled(Container).attrs(props => ({
  border: typeof props.border === 'boolean' ? props.border : true
}))`
  > * {
  }

  justify-content:space-between ;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    flex-direction: column;

    > * {
      flex-basis: auto;
    }

    > * + * {
    }
  }
`;

const Cardv2 = styled.div`
  background-color: red;

  width: 264px;
 
  border-radius: 8px;
  background: #fff;
  border: 1px solid #ccc;
  padding: 20px;
  padding-top: 0px;



font-family: "Elevance Sans Regular";

font-size: 18px;
line-height: 26px;
text-align: left;
color: #131331;


  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: auto;
    margin-right: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
  }

  > p {
    margin-top: 10px;
  }
`;

const CardIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 0px 0px 8px 8px;
  background: #286ce2;
  font-family: 'Elevance Sans Regular';
  font-weight: 500;
  font-size: 36px;
  line-height: 48px;
  text-align: center;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;
